export default __webpack_public_path__ + "file-icons.svg";